import type Contact from '../../../models/Contact';

export interface InvestorDraft {
  markdown: string;
  intentText?: string;
  groundingText?: string;
  sandboxSearchEnabled?: boolean;
  contactId: string | null;
  contactLabel: string | null;
  savedAt: string;
}

export const DRAFT_KEY = 'vera_proposal_draft';

export const GLOBAL_STARTER_PROMPTS = [
  "What's changed in my portfolio over the last 30 days?",
  'Tell me about upcoming opportunities?',
  'Do I have any capital movements coming up?',
];

export const OPPORTUNITY_STARTER_PROMPTS = [
  'Can you tell me more about this location?',
  "What's the minimum investment?",
  'How do I submit an EOI?',
];

export function draftTextEqual(left: string | undefined, right: string): boolean {
  return (left ?? '').trim() === right.trim();
}

export function investorDraftHasUnsavedChanges(
  draft: InvestorDraft,
  production: { markdown: string; intent: string; grounding: string },
): boolean {
  return (
    !draftTextEqual(draft.markdown, production.markdown) ||
    (draft.intentText !== undefined && !draftTextEqual(draft.intentText, production.intent)) ||
    (draft.groundingText !== undefined &&
      !draftTextEqual(draft.groundingText, production.grounding)) ||
    draft.sandboxSearchEnabled === true
  );
}

export function parseInvestorDraft(raw: string | null): InvestorDraft | null {
  if (!raw) return null;
  try {
    return JSON.parse(raw) as InvestorDraft;
  } catch {
    return null;
  }
}

export function formatProposalChipLabel(promptKey: string): string {
  if (promptKey === 'system') return 'System Prompt changed';
  if (promptKey === 'intent') return 'Intent Prompt changed';
  if (promptKey === 'admin_assist_intent') return 'Classifier Prompt changed';
  if (promptKey === 'admin_assist_grounding') return 'Google Search Prompt changed';
  return 'Vera Admin Assist changed';
}

export function formatChangedPromptLabel(promptKey: string): string {
  if (promptKey === 'system') return 'System Prompt';
  if (promptKey === 'intent') return 'Intent Prompt';
  return 'Vera Admin Assist';
}

export function contactLabel(contact: Contact | null): string | null {
  if (!contact) return null;
  return `${contact.firstName} ${contact.lastName}`;
}
